/* GENERATED FILE */
import type { ReactElement } from "react";
import { Fragment } from "react";
import type { IconVariant } from "../lib";

export default new Map<IconVariant, ReactElement>([
	[
		"duocolor",
		<Fragment key={"duocolor"}>
			<path
				opacity="0.4"
				d="M6 17V7M18 17V7"
				stroke="currentColor"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
			<path
				d="M9 15L10.2 12.6M10.2 12.6L12 9L13.8 12.6M10.2 12.6C10.2 12.6 10.8 13.2 12 13.2C13.2 13.2 13.8 12.6 13.8 12.6M13.8 12.6L15 15M10 22H14C16.8003 22 18.2004 22 19.27 21.455C20.2108 20.9757 20.9757 20.2108 21.455 19.27C22 18.2004 22 16.8003 22 14V10C22 7.19974 22 5.79961 21.455 4.73005C20.9757 3.78924 20.2108 3.02433 19.27 2.54497C18.2004 2 16.8003 2 14 2H10C7.19974 2 5.79961 2 4.73005 2.54497C3.78924 3.02433 3.02433 3.78924 2.54497 4.73005C2 5.79961 2 7.19974 2 10V14C2 16.8003 2 18.2004 2.54497 19.27C3.02433 20.2108 3.78924 20.9757 4.73005 21.455C5.79961 22 7.19974 22 10 22Z"
				stroke="currentColor"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
		</Fragment>,
	],
	[
		"duotone",
		<Fragment key={"duotone"}>
			<rect
				opacity="0.12"
				x="2"
				y="2"
				width="20"
				height="20"
				rx="5"
				fill="currentColor"
			/>
			<path
				d="M6 17V7M18 17V7M9 15L10.2 12.6M10.2 12.6L12 9L13.8 12.6M10.2 12.6C10.2 12.6 10.8 13.2 12 13.2C13.2 13.2 13.8 12.6 13.8 12.6M13.8 12.6L15 15M10 22H14C16.8003 22 18.2004 22 19.27 21.455C20.2108 20.9757 20.9757 20.2108 21.455 19.27C22 18.2004 22 16.8003 22 14V10C22 7.19974 22 5.79961 21.455 4.73005C20.9757 3.78924 20.2108 3.02433 19.27 2.54497C18.2004 2 16.8003 2 14 2H10C7.19974 2 5.79961 2 4.73005 2.54497C3.78924 3.02433 3.02433 3.78924 2.54497 4.73005C2 5.79961 2 7.19974 2 10V14C2 16.8003 2 18.2004 2.54497 19.27C3.02433 20.2108 3.78924 20.9757 4.73005 21.455C5.79961 22 7.19974 22 10 22Z"
				stroke="currentColor"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
		</Fragment>,
	],
	[
		"filled",
		<Fragment key={"filled"}>
			<path
				fillRule="evenodd"
				clipRule="evenodd"
				d="M3.98005 1.79497C5.04961 1.25 6.44974 1.25 9.25 1.25H14.75C17.5503 1.25 18.9504 1.25 20.02 1.79497C20.9608 2.27433 21.7257 3.03924 22.205 3.98005C22.75 5.04961 22.75 6.44974 22.75 9.25V14.75C22.75 17.5503 22.75 18.9504 22.205 20.02C21.7257 20.9608 20.9608 21.7257 20.02 22.205C18.9504 22.75 17.5503 22.75 14.75 22.75H9.25C6.44974 22.75 5.04961 22.75 3.98005 22.205C3.03924 21.7257 2.27433 20.9608 1.79497 20.02C1.25 18.9504 1.25 17.5503 1.25 14.75V9.25C1.25 6.44974 1.25 5.04961 1.79497 3.98005C2.27433 3.03924 3.03924 2.27433 3.98005 1.79497ZM6.75 7C6.75 6.58579 6.41421 6.25 6 6.25C5.58579 6.25 5.25 6.58579 5.25 7V17C5.25 17.4142 5.58579 17.75 6 17.75C6.41421 17.75 6.75 17.4142 6.75 17V7ZM18.75 7C18.75 6.58579 18.4142 6.25 18 6.25C17.5858 6.25 17.25 6.58579 17.25 7V17C17.25 17.4142 17.5858 17.75 18 17.75C18.4142 17.75 18.75 17.4142 18.75 17V7ZM12.6708 8.66459C12.5438 8.4105 12.2841 8.25 12 8.25C11.7159 8.25 11.4562 8.4105 11.3292 8.66459L9.52918 12.2646L8.32918 14.6646C8.14394 15.0351 8.29411 15.4856 8.66459 15.6708C9.03507 15.8561 9.48558 15.7059 9.67082 15.3354L10.5085 13.6601C10.8846 13.819 11.3832 13.95 12 13.95C12.6168 13.95 13.1154 13.819 13.4915 13.6601L14.3292 15.3354C14.5144 15.7059 14.9649 15.8561 15.3354 15.6708C15.7059 15.4856 15.8561 15.0351 15.6708 14.6646L14.4708 12.2646L12.6708 8.66459ZM12 12.45C11.6563 12.45 11.3845 12.3877 11.1817 12.3136L12 10.6771L12.8183 12.3136C12.6155 12.3877 12.3437 12.45 12 12.45Z"
				fill="currentColor"
			/>
		</Fragment>,
	],
	[
		"gestalt",
		<Fragment key={"gestalt"}>
			<path
				d="M9.5 2L9 2V2C7.13872 2 6.20808 2 5.45492 2.24472C3.93273 2.73931 2.73931 3.93273 2.24472 5.45492C2 6.20808 2 7.13872 2 9L2 14C2 16.8003 2 18.2004 2.54497 19.27C3.02434 20.2108 3.78924 20.9757 4.73005 21.455C5.79961 22 7.19974 22 10 22H14C16.8003 22 18.2004 22 19.27 21.455C20.2108 20.9757 20.9757 20.2108 21.455 19.27C22 18.2004 22 16.8003 22 14V9C22 7.13872 22 6.20808 21.7553 5.45492C21.2607 3.93273 20.0673 2.73931 18.5451 2.24472C17.7919 2 16.8613 2 15 2V2L14.5 2M6 17V7M18 17V7M9 15L10.2 12.6M10.2 12.6L12 9L13.8 12.6M10.2 12.6C10.2 12.6 10.8 13.2 12 13.2C13.2 13.2 13.8 12.6 13.8 12.6M13.8 12.6L15 15"
				stroke="currentColor"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
		</Fragment>,
	],
	[
		"line",
		<Fragment key={"line"}>
			<path
				d="M6 17V7M18 17V7M9 15L10.2 12.6M10.2 12.6L12 9L13.8 12.6M10.2 12.6C10.2 12.6 10.8 13.2 12 13.2C13.2 13.2 13.8 12.6 13.8 12.6M13.8 12.6L15 15M10 22H14C16.8003 22 18.2004 22 19.27 21.455C20.2108 20.9757 20.9757 20.2108 21.455 19.27C22 18.2004 22 16.8003 22 14V10C22 7.19974 22 5.79961 21.455 4.73005C20.9757 3.78924 20.2108 3.02433 19.27 2.54497C18.2004 2 16.8003 2 14 2H10C7.19974 2 5.79961 2 4.73005 2.54497C3.78924 3.02433 3.02433 3.78924 2.54497 4.73005C2 5.79961 2 7.19974 2 10V14C2 16.8003 2 18.2004 2.54497 19.27C3.02433 20.2108 3.78924 20.9757 4.73005 21.455C5.79961 22 7.19974 22 10 22Z"
				stroke="currentColor"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
		</Fragment>,
	],
	[
		"mono",
		<Fragment key={"mono"}>
			<path
				opacity="0.32"
				d="M9.25 1.25C6.44974 1.25 5.04961 1.25 3.98005 1.79497C3.03924 2.27433 2.27433 3.03924 1.79497 3.98005C1.25 5.04961 1.25 6.44974 1.25 9.25V14.75C1.25 17.5503 1.25 18.9504 1.79497 20.02C2.27433 20.9608 3.03924 21.7257 3.98005 22.205C5.04961 22.75 6.44974 22.75 9.25 22.75H14.75C17.5503 22.75 18.9504 22.75 20.02 22.205C20.9608 21.7257 21.7257 20.9608 22.205 20.02C22.75 18.9504 22.75 17.5503 22.75 14.75V9.25C22.75 6.44974 22.75 5.04961 22.205 3.98005C21.7257 3.03924 20.9608 2.27433 20.02 1.79497C18.9504 1.25 17.5503 1.25 14.75 1.25H9.25Z"
				fill="currentColor"
			/>
			<path
				fillRule="evenodd"
				clipRule="evenodd"
				d="M6 6.25C6.41421 6.25 6.75 6.58579 6.75 7V17C6.75 17.4142 6.41421 17.75 6 17.75C5.58579 17.75 5.25 17.4142 5.25 17V7C5.25 6.58579 5.58579 6.25 6 6.25ZM18 6.25C18.4142 6.25 18.75 6.58579 18.75 7V17C18.75 17.4142 18.4142 17.75 18 17.75C17.5858 17.75 17.25 17.4142 17.25 17V7C17.25 6.58579 17.5858 6.25 18 6.25ZM12 8.25C12.2841 8.25 12.5438 8.4105 12.6708 8.66459L14.4708 12.2646L15.6708 14.6646C15.8561 15.0351 15.7059 15.4856 15.3354 15.6708C14.9649 15.8561 14.5144 15.7059 14.3292 15.3354L13.4915 13.6601C13.1154 13.819 12.6168 13.95 12 13.95C11.3832 13.95 10.8846 13.819 10.5085 13.6601L9.67082 15.3354C9.48558 15.7059 9.03507 15.8561 8.66459 15.6708C8.29411 15.4856 8.14394 15.0351 8.32918 14.6646L9.52918 12.2646L11.3292 8.66459C11.4562 8.4105 11.7159 8.25 12 8.25ZM11.1817 12.3136C11.3845 12.3877 11.6563 12.45 12 12.45C12.3437 12.45 12.6155 12.3877 12.8183 12.3136L12 10.6771L11.1817 12.3136Z"
				fill="currentColor"
			/>
		</Fragment>,
	],
]);
